import NoteTextarea from './NoteTextarea';

export default NoteTextarea;